import { ColumnsType } from 'antd/lib/table';
import { NctsConsignmentItem } from 'store/declarations/ireland/ncts-declaration';
import getItemNumberColumn from 'views/declarations/common/getItemNumberColumn';

const compareText = (a?: string, b?: string) => (a ?? '-').localeCompare(b ?? '-');

const getNCTSProductsTableColumns: (
    handleTableValues: (index: number, value: any) => any
) => ColumnsType<NctsConsignmentItem> = (handleTableValues) => [
    getItemNumberColumn((record: NctsConsignmentItem) => record.goodsItemNumber),
    {
        title: 'Harmonized System Sub-Heading Code',
        key: 'harmonized_code',
        render: (_, record, index) => {
            return handleTableValues(index, record?.commodity?.commodityCode?.harmonizedSystemSubHeadingCode ?? '-');
        },
        sorter: (a, b) => {
            return compareText(
                a.commodity?.commodityCode?.harmonizedSystemSubHeadingCode,
                b.commodity?.commodityCode?.harmonizedSystemSubHeadingCode
            );
        },
    },
    {
        title: 'Combined Nomenclature Code',
        key: 'combined_nomenclature_code',
        render: (_, record, index) => {
            return handleTableValues(index, record?.commodity?.commodityCode?.combinedNomenclatureCode ?? '-');
        },
        sorter: (a, b) => {
            return compareText(
                a.commodity?.commodityCode?.combinedNomenclatureCode,
                b.commodity?.commodityCode?.combinedNomenclatureCode
            );
        },
    },
    {
        title: 'Description of Goods',
        key: 'description_of_goods',
        render: (_, record, index) => {
            return handleTableValues(index, record?.commodity?.descriptionOfGoods ?? '-');
        },
        sorter: (a, b) => {
            return compareText(a.commodity?.descriptionOfGoods, b.commodity?.descriptionOfGoods);
        },
    },
    {
        title: 'Net Mass',
        key: 'net_mass',
        render: (_, record, index) => {
            return handleTableValues(index, record?.commodity?.goodsMeasure?.netMass);
        },
        sorter: (a, b) => {
            return (a.commodity?.goodsMeasure?.netMass ?? 0) - (b.commodity?.goodsMeasure?.netMass ?? 0);
        },
    },
];

export default getNCTSProductsTableColumns;
